import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getForecastTypes = createAsyncThunk('getForecastTypes', async () => {
    const response = await axios.get(`/lookup/forecast-types`);

    return response.data;
});
